import { render, staticRenderFns } from "./vcard.vue?vue&type=template&id=7d880976&scoped=true&"
import script from "./vcard.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./vcard.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./vcard.vue?vue&type=style&index=0&id=7d880976&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d880976",
  null
  
)

export default component.exports